import React from "react";
import { Row, Col } from "react-bootstrap";

import { GeneralInformation } from "../GeneralInformation";
import { MaintainNavigation } from "../navigation/MaintainNavigation";
import { Operations } from "../Operations";

export const GeneralInformationPage: React.FC = () => {
	return (
		<div>
			<Row>
				<Col sm={3}>
					<MaintainNavigation activePage="general" />
				</Col>
				<Col sm={9}>
					<GeneralInformation />
					<Operations />
				</Col>
			</Row>
		</div>
	);
};
